import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, TrafficLayer} from 'react-google-maps';

import AppConfig from "AppConfig";

const LUX_COORDINATES = { lat: 49.64, lng: 6.10 };

const OPTIONS = {
    scrollwheel: false,
    streetViewControl: false,
    panControl: true,
    maxZoom:20,
    minZoom:3
};

class TrafficRoadmapComponent extends React.Component {

    constructor() {
        super();

        this.state = { center: LUX_COORDINATES }
    }

    handleClick = () => {
        window.logAction();
        this.setState({center: LUX_COORDINATES})
    };

    componentDidUpdate() {
        window.pymChild && window.pymChild.sendHeight();
    }

    render() {
        const Map = withScriptjs(withGoogleMap( () => (
            <GoogleMap
                defaultCenter = { this.state.center }
                defaultZoom = {10}
                defaultOptions = {OPTIONS}
            >
                <TrafficLayer autoUpdate />
            </GoogleMap>
        )));

        return (
            <div>
                <Map
                    containerElement={ <div style={{height: `400px`}}></div> }
                    mapElement={ <div style={{ height: `100%` }}></div> }
                    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${AppConfig.googleMapApiKey}&libraries=geometry,drawing,places`}
                    loadingElement={<div style={{ height: `100%` }} />}
                />
                <input className="traffic-page__center-button" type="button" onClick={this.handleClick} value="center"/>
            </div>
        );
    }
}

export default TrafficRoadmapComponent;



// WEBPACK FOOTER //
// ./js/services/traffic/TrafficRoadmapComponent.js